'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
import { Theme } from 'src/Theme';
const PageHeaderWrapper = styled(FlexColumn)<{
  toolbar?: React.ReactNode;
}>(({
  theme,
  toolbar
}) => ({
  alignItems: 'center',
  gap: theme.sizes.spacing['02'],
  padding: `${theme.sizes.spacing['09']} ${theme.sizes.spacing['10']} ${toolbar ? theme.sizes.spacing.none : theme.sizes.spacing['09']}
     ${theme.sizes.spacing['10']} `,
  alignSelf: 'stretch',
  backgroundColor: theme.colors.surface.tertiary,
  borderBottom: `${theme.sizes.borderWidth[1]} solid ${theme.colors.border.secondary} `,
  justifyContent: 'center'
}));
const ContentWrapper = styled(FlexColumn)(({
  theme
}) => ({
  alignItems: 'flex-start',
  gap: theme.sizes.spacing['07'],
  padding: `${theme.sizes.spacing.none}`,
  alignSelf: 'stretch'
}));
interface PageHeaderProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
  toolbar?: React.ReactNode;
}
const PageHeader: React.FC<PageHeaderProps> = t0 => {
  const $ = _c(14);
  const {
    title,
    description,
    children,
    toolbar
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = title && <Typography variant="heading-3xl" component="span">{title}</Typography>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description && <Typography variant="body1" component="p">{description}</Typography>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <ContentWrapper>{t1}{t2}{children}</ContentWrapper>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== toolbar) {
    t4 = toolbar ? <FlexColumn sx={_temp}>{toolbar}</FlexColumn> : null;
    $[8] = toolbar;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== toolbar) {
    t5 = <PageHeaderWrapper toolbar={toolbar}>{t3}{t4}</PageHeaderWrapper>;
    $[10] = t3;
    $[11] = t4;
    $[12] = toolbar;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default PageHeader;
export type { PageHeaderProps };
function _temp(theme) {
  return {
    alignSelf: "flex-start",
    paddingTop: theme.sizes.spacing["09"]
  };
}